import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Table, Modal, Form, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import api from '../../services/api'; // Corrigido o caminho para a instância configurada do Axios
import './BannerManager.css';

// Nota: Estamos usando os componentes do React Bootstrap diretamente importados
// Removemos as implementações personalizadas que estavam causando conflitos

// Estilos personalizados para o formulário de banner
const styles = {
  bannerForm: {
    fontSize: '16px',
  },
  formLabel: {
    fontSize: '16px',
    marginBottom: '8px',
  },
  previewContainer: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    marginTop: '15px',
  },
  fileInput: {
    padding: '10px',
    border: '1px dashed #ccc',
    borderRadius: '5px',
    background: '#fff',
  },
  modalHeader: {
    background: 'linear-gradient(135deg, #4a6bff 0%, #2541b2 100%)',
    color: 'white',
  },
  bannerTable: {
    fontSize: '14px',
  },
  activeStatus: {
    background: '#d4edda',
    color: '#155724',
    padding: '3px 8px',
    borderRadius: '4px',
    fontWeight: 'bold',
  },
  inactiveStatus: {
    background: '#f8d7da',
    color: '#721c24',
    padding: '3px 8px',
    borderRadius: '4px',
  },
  modal: {
    zIndex: 1060 // Garante que o modal fique acima da sidebar (que geralmente tem z-index ~1030)
  }
};

const BannerManager = () => {
  // Estados
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showModal, setShowModal] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null,
    image_path: '',
    link_url: '',
    is_active: false,
    start_date: '',
    end_date: ''
  });
  const [previewUrl, setPreviewUrl] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  // Carregar banners ao iniciar
  useEffect(() => {
    fetchBanners();
  }, []);

  // Função para buscar banners
  const fetchBanners = async () => {
    setLoading(true);
    try {
      const response = await api.get('/banners.php'); // Usar a baseURL da instância
      setBanners(response.data.banners || []);
    } catch (error) {
      console.error('Erro ao buscar banners:', error);
      setMessage({
        text: `Erro ao buscar banners: ${error.response?.data?.error || error.message}`,
        type: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  // Função para abrir modal de adição
  const handleAddNew = () => {
    setFormData({
      title: '',
      description: '',
      image: null,
      image_path: '',
      link_url: '',
      is_active: false,
      start_date: '',
      end_date: ''
    });
    setPreviewUrl('');
    setIsEditing(false);
    setShowModal(true);
  };

  // Função para abrir modal de edição
  const handleEdit = (banner) => {
    setFormData({
      id: banner.id,
      title: banner.title || '',
      description: banner.description || '',
      image: null,
      image_path: banner.image_path || '',
      link_url: banner.link_url || '',
      is_active: banner.is_active === 1,
      start_date: banner.start_date ? banner.start_date.substring(0, 16) : '',
      end_date: banner.end_date ? banner.end_date.substring(0, 16) : ''
    });
    setPreviewUrl(banner.image_path ? `/uploads/banners/${banner.image_path.split('/').pop()}` : '');
    setIsEditing(true);
    setCurrentBanner(banner);
    setShowModal(true);
  };

  // Função para alternar status ativo/inativo
  const handleToggleActive = async (id) => {
    try {
      setLoading(true);
      console.log('Alternando status do banner ID:', id);

      const response = await api.patch('/banners.php', { id });
      console.log('Resposta do servidor:', response.data);

      if (response.data.success) {
        setMessage({
          text: response.data.message,
          type: 'success'
        });

        // Atualizar a lista de banners
        fetchBanners();
      } else {
        throw new Error(response.data.error || 'Erro ao alterar status');
      }
    } catch (error) {
      console.error('Erro ao alterar status do banner:', error);
      setMessage({
        text: `Erro ao alterar status: ${error.response?.data?.error || error.message}`,
        type: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  // Função para excluir banner
  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este banner?')) {
      return;
    }

    try {
      setLoading(true);
      console.log('Excluindo banner ID:', id);

      // Usar URL com parâmetro de consulta para o ID em vez de enviar no corpo
      const response = await api.delete(`/banners.php?id=${id}`);
      console.log('Resposta do servidor:', response.data);

      // Log da resposta do servidor
      console.log('Resposta completa do servidor:', response);

      if (response.data.success) {
        setMessage({ text: response.data.message || 'Operação bem-sucedida!', type: 'success' });
        setShowModal(false);
        fetchBanners();
      } else {
        // Adiciona um log específico para falhas retornadas pela API
        console.error('A API retornou um erro:', response.data.error || response.data);
        setMessage({ text: response.data.error || 'Ocorreu um erro desconhecido no servidor.', type: 'danger' });
      }
    } catch (error) {
      console.error('Erro ao excluir banner:', error);
      setMessage({
        text: `Erro ao excluir banner: ${error.response?.data?.error || error.message}`,
        type: 'danger'
      });
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };


  // Função para lidar com mudanças no formulário
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    console.log(`Campo alterado: ${name}, Valor: ${type === 'file' ? 'arquivo' : value}`);
    
    // Criar uma cópia atualizada do estado para uso nos logs
    const updatedFormData = { ...formData };
    
    if (type === 'file') {
      if (files && files[0]) {
        updatedFormData.image = files[0];
        setFormData(updatedFormData);
        
        // Criar URL para preview
        const fileUrl = URL.createObjectURL(files[0]);
        setPreviewUrl(fileUrl);
      }
    } else if (type === 'checkbox') {
      updatedFormData[name] = checked;
      setFormData(updatedFormData);
    } else {
      updatedFormData[name] = value;
      setFormData(updatedFormData);
    }
    
    // Log do estado atualizado do formulário usando a cópia atualizada
    console.log('Estado do formulário após alteração:', name, updatedFormData);
  };

  // Função para enviar formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('handleSubmit foi chamado com sucesso!');
    setLoading(true);
    
    // Log detalhado para diagnóstico
    console.log('=== INICIANDO ENVIO DO FORMULÁRIO ===');
    console.log('Evento:', e.type);
    console.log('Estado do formulário completo:', formData);
    console.log('Tipo da imagem:', formData.image ? formData.image.type : 'Nenhuma imagem');
    console.log('Tamanho da imagem:', formData.image ? formData.image.size + ' bytes' : 'Nenhuma imagem');

    try {
      let response;

      if (isEditing) {
        // Se estiver editando
        // Sempre usar FormData para consistência
        const data = new FormData();
        
        // Log do estado do formulário antes de criar o FormData
        console.log('Estado do formulário antes de criar FormData:', JSON.stringify(formData, null, 2));
        
        // Adicionar explicitamente cada campo ao FormData
        // IMPORTANTE: Sempre enviar todos os campos, mesmo vazios
        data.append('id', formData.id);
        data.append('title', formData.title || '');
        data.append('description', formData.description || '');
        data.append('link_url', formData.link_url || '');
        data.append('is_active', formData.is_active ? 1 : 0);
        
        // Sempre adicionar campos de data, mesmo vazios
        data.append('start_date', formData.start_date || '');
        data.append('end_date', formData.end_date || '');
        
        // Adicionar imagem apenas se houver uma nova
        if (formData.image) {
          console.log('Adicionando nova imagem ao FormData:', formData.image.name);
          console.log('Tipo da imagem:', formData.image.type);
          console.log('Tamanho da imagem:', formData.image.size, 'bytes');
          data.append('image', formData.image);
        } else {
          console.log('Nenhuma nova imagem selecionada para upload');
        }
        
        // Verificar o conteúdo do FormData
        console.log('Conteúdo do FormData:');
        for (let pair of data.entries()) {
          console.log(pair[0] + ': ' + (pair[0] === 'image' ? 'Arquivo' : pair[1]));
        }
        
        console.log('Enviando PUT com FormData para:', `/banners.php?method=PUT&id=${formData.id}`);
        
        response = await api.post( // Manter POST para compatibilidade com PHP ao enviar arquivos
          `/banners.php?method=PUT&id=${formData.id}`,
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
      } else {
        // Se estiver adicionando novo
        if (formData.image) {
          // Se tiver imagem, enviar como FormData
          const data = new FormData();

          // Adicionar todos os campos ao FormData
          Object.keys(formData).forEach(key => {
            if (key === 'image') {
              console.log('Adicionando imagem ao FormData:', formData[key].name);
              console.log('Tipo da imagem:', formData[key].type);
              console.log('Tamanho da imagem:', formData[key].size, 'bytes');
              data.append('image', formData[key]);
            } else if (key === 'is_active') {
              data.append(key, formData[key] ? 1 : 0);
            } else if (formData[key] !== null && formData[key] !== undefined) {
              // Garantir que todos os campos sejam enviados, mesmo vazios
              data.append(key, formData[key]);
            }
          });

          // Verificar o conteúdo do FormData
          for (let pair of data.entries()) {
            console.log(pair[0] + ': ' + (pair[0] === 'image' ? 'Arquivo' : pair[1]));
          }

          console.log('Enviando POST com FormData');

          response = await api.post(
            '/banners.php',
            data,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          );
        } else {
          // Se não tiver imagem, mostrar erro - imagem é obrigatória para novos banners
          throw new Error('A imagem é obrigatória para criar um novo banner.');
        }
      }

      // Log da resposta do servidor para depuração
      console.log('Resposta completa do servidor:', response);

      if (response.data.success) {
        setMessage({ text: response.data.message || 'Operação bem-sucedida!', type: 'success' });
        setShowModal(false);
        fetchBanners();
      } else {
        // Adiciona um log específico para falhas retornadas pela API (success: false)
        console.error('A API indicou uma falha:', response.data.error || response.data);
        setMessage({ text: response.data.error || 'Ocorreu um erro no servidor.', type: 'danger' });
      }
    } catch (error) {
      // Log detalhado do erro (falha na requisição)
      console.error('Ocorreu um erro ao enviar o formulário:', error);

      if (error.response) {
        // O servidor respondeu com um status de erro (4xx, 5xx)
        console.error('Dados do erro (response.data):', error.response.data);
        console.error('Status do erro (response.status):', error.response.status);

        const errorMessage = typeof error.response.data === 'string'
          ? 'O servidor retornou um erro inesperado. Verifique o console para a resposta completa (pode ser HTML).'
          : error.response.data.error || JSON.stringify(error.response.data);
        setMessage({ text: `Falha na comunicação: ${errorMessage}`, type: 'danger' });

      } else if (error.request) {
        // A requisição foi feita, mas não houve resposta
        console.error('Nenhuma resposta recebida do servidor:', error.request);
        setMessage({ text: 'Não foi possível conectar ao servidor. Verifique a rede e se o backend está rodando.', type: 'danger' });
      } else {
        // Erro na configuração da requisição no frontend
        console.error('Erro ao configurar a requisição:', error.message);
        setMessage({ text: `Erro na aplicação: ${error.message}`, type: 'danger' });
      }
    } finally {
      setLoading(false);
    }
  };

  // Função para limpar mensagem
  const clearMessage = () => {
    setMessage({ text: '', type: '' });
  };

  return (
    <Container>
      <h2 className="mb-4">Gerenciamento de Banners</h2>

      {message.text && (
        <Alert variant={message.type} dismissible onClose={clearMessage}>
          {message.text}
        </Alert>
      )}

      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <span>Banners</span>
          <Button variant="success" onClick={handleAddNew}>Adicionar Novo Banner</Button>
        </Card.Header>
        <Card.Body>
          {loading ? (
            <p>Carregando banners...</p>
          ) : banners.length === 0 ? (
            <p>Nenhum banner cadastrado.</p>
          ) : (
            <Table striped bordered hover responsive style={styles.bannerTable}>
              <thead className="table-primary">
                <tr>
                  <th>ID</th>
                  <th>Imagem</th>
                  <th>Título</th>
                  <th>Status</th>
                  <th>Período</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {banners.map(banner => (
                  <tr key={banner.id}>
                    <td>{banner.id}</td>
                    <td>
                      {banner.image_path && (
                        <img
                          src={`http://localhost:8080/catalogo/${banner.image_path}`}
                          alt={banner.title || 'Banner'}
                          style={{ maxHeight: '50px', maxWidth: '100px' }}
                        />
                      )}
                    </td>
                    <td>{banner.title || 'Sem título'}</td>
                    <td>{banner.link_url || 'Sem link'}</td>
                    <td>
                      <span style={banner.is_active ? styles.activeStatus : styles.inactiveStatus}>
                        {banner.is_active ? '✓ Ativo' : '✗ Inativo'}
                      </span>
                    </td>
                    <td>
                      {banner.start_date_formatted || 'Sem data'} até {banner.end_date_formatted || 'Sem data'}
                    </td>
                    <td>
                      <div className="btn-group">
                        <Button
                          variant="outline-primary"
                          className="btn-sm"
                          onClick={() => handleEdit(banner)}
                        >
                          Editar
                        </Button>
                        <Button
                          variant={banner.is_active === 1 ? "outline-warning" : "outline-success"}
                          className="btn-sm"
                          onClick={() => handleToggleActive(banner.id)}
                        >
                          {banner.is_active === 1 ? 'Desativar' : 'Ativar'}
                        </Button>
                        <Button
                          variant="outline-danger"
                          className="btn-sm"
                          onClick={() => handleDelete(banner.id)}
                        >
                          Excluir
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        size="lg" 
        centered 
        style={styles.modal} 
        backdrop="static"
        className="banner-modal"
      >
        <Modal.Header closeButton style={styles.modalHeader}>
          <Modal.Title>{isEditing ? 'Editar Banner' : 'Adicionar Novo Banner'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {message && (
            <Alert variant={message.type} className="mb-4" dismissible onClose={() => setMessage(null)}>
              {message.text}
            </Alert>
          )}
        <Form 
          id="bannerForm" 
          onSubmit={handleSubmit}
          style={styles.bannerForm} 
          className="banner-form" 
          noValidate
        >
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold" style={styles.formLabel}>Título <span className="text-muted">(opcional)</span></Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title || ''}
              onChange={handleChange}
              placeholder="Título do banner"
              className="form-control-lg shadow-sm"
            />
            <Form.Text className="text-muted">Um título curto e atrativo para o banner</Form.Text>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold" style={styles.formLabel}>Descrição <span className="text-muted">(opcional)</span></Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description || ''}
              onChange={handleChange}
              placeholder="Descrição do banner"
              rows={3}
              className="shadow-sm"
            />
            <Form.Text className="text-muted">Uma breve descrição do conteúdo ou promoção do banner</Form.Text>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold" style={styles.formLabel}>
              {isEditing ? 'Imagem' : 'Imagem'} 
              {isEditing && <span className="text-muted">(deixe em branco para manter a atual)</span>}
            </Form.Label>
            <div className="custom-file-upload mb-2" style={styles.fileInput}>
              <Form.Control
                type="file"
                name="image"
                onChange={handleChange}
                accept="image/*"
                required={!isEditing && !formData.image_path}
                className="shadow-sm"
              />
            </div>
            <Form.Text className="text-muted d-block mb-3">Formatos recomendados: JPG, PNG, GIF ou WEBP. Tamanho ideal: 1920x500 pixels.</Form.Text>
            {previewUrl && (
              <div style={styles.previewContainer} className="mt-3 text-center rounded border">
                <p className="small text-muted mb-1">Pré-visualização:</p>
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxHeight: '200px', maxWidth: '100%', objectFit: 'contain' }}
                />
              </div>
            )}
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold" style={styles.formLabel}>Link URL <span className="text-muted">(opcional)</span></Form.Label>
            <InputGroup className="shadow-sm">
              <InputGroup.Text>🔗</InputGroup.Text>
              <Form.Control
                type="url"
                name="link_url"
                value={formData.link_url || ''}
                onChange={handleChange}
                placeholder="https://exemplo.com"
              />
            </InputGroup>
            <Form.Text className="text-muted">URL para onde o usuário será direcionado ao clicar no banner</Form.Text>
          </Form.Group>

          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold" style={styles.formLabel}>Data de Início <span className="text-muted">(opcional)</span></Form.Label>
                <InputGroup className="shadow-sm">
                  <InputGroup.Text>📅</InputGroup.Text>
                  <Form.Control
                    type="datetime-local"
                    name="start_date"
                    value={formData.start_date}
                    onChange={handleChange}
                  />
                </InputGroup>
                <Form.Text className="text-muted">Quando o banner começará a ser exibido</Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold" style={styles.formLabel}>Data de Fim <span className="text-muted">(opcional)</span></Form.Label>
                <InputGroup className="shadow-sm">
                  <InputGroup.Text>🗓️</InputGroup.Text>
                  <Form.Control
                    type="datetime-local"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </InputGroup>
                <Form.Text className="text-muted">Quando o banner deixará de ser exibido</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3 p-3 bg-light rounded border">
            <Form.Check
              type="checkbox"
              id="is-active-checkbox"
              label={<span className="fw-bold">Ativar este banner?</span>}
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              className="form-switch"
            />
            <Form.Text className="text-muted d-block mt-2 ms-4">
              ℹ️ Se marcado, outros banners ativos serão automaticamente desativados
            </Form.Text>
          </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button
            variant="primary"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              console.log('Botão salvar clicado diretamente');
              
              // Submeter o formulário manualmente usando o evento submit
              const form = document.getElementById('bannerForm');
              if (form) {
                console.log('Formulário encontrado, disparando evento submit');
                // Criar e disparar um evento de submit para acionar o handleSubmit
                const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
                form.dispatchEvent(submitEvent);
              } else {
                console.error('Formulário não encontrado!');
              }
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Salvando...
              </>
            ) : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="mb-4">
        <h4>Instruções</h4>
        <ul>
          <li>Os banners são exibidos na página inicial do site.</li>
          <li>Apenas um banner pode estar ativo por vez.</li>
          <li>Você pode definir datas de início e fim para programar a exibição dos banners.</li>
          <li>Banners sem data de início/fim ficarão ativos até serem desativados manualmente.</li>
          <li>Imagens recomendadas: 1920x500 pixels para melhor visualização.</li>
          <li>Formatos suportados: JPG, PNG, GIF e WEBP.</li>
        </ul>
      </div>
    </Container>
  );
};

export default BannerManager;
